module.exports = __webpack_public_path__ + "img/6.5f12c0a.png";